

















































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import Icon from '@/dex-shared/components/Icon.vue';
import SpeechBubbleMenu from '@/dex-shared/components/SpeechBubbleMenu.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

const LOCAL_STORAGE_KEY = 'seenDexEssays';

export default Vue.extend({
  components: {
    Icon,
    SpeechBubbleMenu,
    pxButton,
  },
  data() {
    return {
      firstTime: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters({
      userLastCourse: 'userLastCourse',
      essaysUrl: 'essaysUrl',
    }),
  },
  created() {
    this.firstTime = !localStorage.getItem(LOCAL_STORAGE_KEY);
  },
  methods: {
    confirmDialog() {
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
      this.firstTime = false;
      this.showTooltip = true;
      setTimeout(() => {
        this.showTooltip = false;
      }, 3000);
    },
    async disableBeta() {
      this.$store.commit('UPDATE_USER_EXPERIMENTS_SETTINGS', false);

      try {
        await this.$store.dispatch('PUSH_USER_EXPERIMENTS_SETTINGS', {
          isEnabled: false,
        });
        window.location.assign(this.essaysUrl);
      } catch (_e) {
        this.$store.commit('UPDATE_USER_EXPERIMENTS_SETTINGS', true);
      }
    },
  },
});
